import { Alert, Box } from '@mui/material';
import { Create } from '@refinedev/mui';
import { useForm } from '@refinedev/react-hook-form';
import { Controller, FormProvider } from 'react-hook-form';

import { ATTACKIQ_ID } from '@attackiq/constants';

import { TextFieldInput } from '../../components';
import { Selector } from '../../components/inputs';
import { UnifiedMitigationContentEditor } from '../../components/inputs/UnifiedMitigationsContentEditor/UnifiedMitigationsContentEditor';

const UnifiedMitigationsCreate = () => {
  const {
    refineCore: { onFinish },
    saveButtonProps,
    ...formMethods
  } = useForm({
    refineCoreProps: { action: 'create' },
    defaultValues: {
      name: '',
      description: '',
      content: '',
      unifiedmitigationtype: null,
      reference_id: null,
      source: 'AttackIQ',
      source_type: 'custom',
      severity: 'medium',
      stage: 'prod',
      is_active: true,
      company_id: ATTACKIQ_ID
    }
  });

  const { control, handleSubmit, watch } = formMethods;

  const onSubmit = handleSubmit(
    ({
      name,
      description,
      content,
      unifiedmitigationtype,
      reference_id,
      source,
      source_type,
      severity,
      stage,
      is_active
    }) => {
      onFinish({
        name,
        description,
        content,
        unifiedmitigationtype,
        reference_id,
        source,
        source_type,
        severity,
        stage,
        is_active,
        company_id: ATTACKIQ_ID
      });
    }
  );

  // TODO: Checkbox could be an input component so that we don't repeat this everywhere
  return (
    <FormProvider {...formMethods}>
      <form name="create-module-form" onSubmit={onSubmit} autoComplete="off">
        <Create saveButtonProps={{ ...saveButtonProps, type: 'submit' }}>
          <Alert severity="info">
            You are creating a UNIFIED MITIGATION. This is the new way of creating mitigations. Note that this operation
            will also create a "Legacy" Mitigation, until we get to remove those.
          </Alert>
          <br />
          <Box display="flex" flexDirection="column" gap={2}>
            <TextFieldInput
              name="name"
              label="Unified Mitigation Name"
              rules={{ required: 'Unified Mitigation Name is required' }}
            />
            <TextFieldInput
              name="description"
              label="Unified Mitigation Description"
              rules={{ required: 'Unified Mitigation Description is required' }}
            />
            <Selector
              resource="unified_mitigation_types"
              label="Unified Mitigation Type"
              control={control}
              name="unifiedmitigationtype"
              rules={{ required: 'Unified Mitigation type is required' }}
            />
            <Controller
              name="content"
              control={control}
              rules={{ required: 'Unified Mitigation content is required' }}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <UnifiedMitigationContentEditor
                  value={value}
                  onChange={onChange}
                  type={watch('unifiedmitigationtype')}
                  readonly={false}
                />
              )}
            />
            <TextFieldInput name="reference_id" label="Reference ID (only useful for certain mitigation types)" />
          </Box>
        </Create>
      </form>
    </FormProvider>
  );
};

export default UnifiedMitigationsCreate;
